import React from "react";
import {
  Box,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { motion } from "framer-motion";

const orange = "#ff6600";
const dark = "#000000";
const grayText = "#444444";
const grayTitle = "#333333";

const items = [
  {
    title: "Soluciones modernas y eficientes",
    desc: "Desarrollamos plataformas optimizadas para diferentes tipos de negocios.",
  },
  {
    title: "Desarrollo seguro y escalable",
    desc: "Nuestras soluciones permiten el crecimiento sin perder estabilidad y rendimiento.",
  },
  {
    title: "Experiencia de usuario optimizada",
    desc: "Creamos interfaces intuitivas y atractivas para mejorar la interacción digital.",
  },
  {
    title: "Ubicados en Quito",
    desc: "Atendemos clientes en toda la región con atención personalizada.",
  },
];

const Development = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#fff",
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 6 },
        overflow: "hidden",
      }}
    >
      <Box sx={{ textAlign: "center", mb: 6, position: "relative", zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, amount: 0.4 }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.3rem" },
              fontWeight: "bold",
              mb: 2,
              color: grayTitle,
            }}
          >
            Desarrollo Web y Aplicaciones
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
              color: grayText,
              maxWidth: "850px",
              textAlign: "justify",
              mx: "auto",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            En <strong style={{ color: orange }}>CMSOLTEC</strong> nos especializamos en el desarrollo de sitios web,
            aplicaciones web y software a medida. Utilizamos tecnologías modernas como Python para crear soluciones seguras,
            rápidas y adaptadas a cada negocio. Digitalizamos procesos, optimizamos recursos y mejoramos la experiencia
            de usuarios y equipos de trabajo.
          </Typography>
        </motion.div>
      </Box>

      <Grid
        container
        spacing={{ xs: 4, md: 8 }}
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          item
          xs={12}
          md={6}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true, amount: 0.3 }}
            style={{ width: "100%", maxWidth: isMobile ? 280 : 420 }}
          >
            <Box
              sx={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 10px 24px rgba(0,0,0,0.25)",
              }}
            >
              <img
                src={require("../../static/media/home/development.webp")}
                alt="Desarrollo Web y Automatización"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Box>
          </motion.div>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          {items.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + index * 0.2, duration: 0.5 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <Box sx={{ mb: 4 }}>
                <Typography
                  component="h3"
                  sx={{
                    fontSize: { xs: "1.05rem", sm: "1.15rem", md: "1.25rem" },
                    fontWeight: "bold",
                    color: dark,
                    mb: 0.5,
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1rem", md: "1.05rem" },
                    color: grayText,
                    lineHeight: 1.6,
                  }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </motion.div>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Development;
